import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Grid as DsGrid } from '@mirohq-internal/design-system';
import { styled, generateGridCenteredVariants, generateGridResponsiveSizeVariants } from '@miro-site/ui-styled-engine';
import { jsx as _jsx } from "react/jsx-runtime";
var GridBase = styled(DsGrid, {
  gap: '$300',
  variants: {
    disableGutter: {
      "false": {
        insetX: '$150'
      },
      "true": {
        insetX: 'unset'
      }
    }
  },
  defaultVariants: {
    disableGutter: false
  }
});
var GridItem = styled(DsGrid.Item, {
  variants: _objectSpread({
    centerEvenSizedColumn: {
      "true": {},
      "false": {}
    }
  }, generateGridResponsiveSizeVariants()),
  compoundVariants: generateGridCenteredVariants()
});

var Grid = function Grid(props) {
  return /*#__PURE__*/_jsx(GridBase, _objectSpread({
    columns: 12
  }, props));
};

export { Grid, GridItem };